/** Limits a form should show, the same numbers the server enforces. */
export const SCHEDULE_LIMITS = {
    name: 100,
    cron: 100,
    /** The input, as JSON text. */
    inputBytes: 10_000,
};
//# sourceMappingURL=schedules.js.map